import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { baseUrl, headers } from '../../api/utils';

export const getStoreDetailsRedux = createAsyncThunk(
  'storeDetails/fetch',
  async () => {
    const response = await axios.get(`${baseUrl}/vendor/getstorefulldetails`, {
        headers: headers
    });
    return response.data;
}
);

const storeDetailsSlice = createSlice({
  name: 'storeDetails',
  initialState: {
    storeData: null,
    storeStatus: 'idle',
    storeError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getStoreDetailsRedux.pending, (state) => {
        state.storeStatus = 'loading';
      })
      .addCase(getStoreDetailsRedux.fulfilled, (state, action) => {
        state.storeStatus = 'succeeded';
        state.storeData = action.payload;
      })
      .addCase(getStoreDetailsRedux.rejected, (state, action) => {
        state.storeStatus = 'failed';
        state.storeError = action.error.message;
      });
  },
});

export default storeDetailsSlice.reducer;
export { getStoreDetailsRedux as fetchStoreDetails };